module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "conInner"
  }, [_c('section', {
    attrs: {
      "id": "content_wrapper"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('ul', [_c('li', {
    class: {
      'selected': _vm.tab == 1
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.changeTab(1)
      }
    }
  }, [_c('span', [_vm._v("收藏的商品")])])]), _vm._v(" "), _c('li', {
    class: {
      'selected': _vm.tab == 2
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.changeTab(2)
      }
    }
  }, [_c('span', [_vm._v("收藏的店铺")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), (_vm.tab == 1) ? _c('div', {
    staticClass: "body"
  }, [(!_vm.favoriteList.length) ? _c('div', {
    staticClass: "empty"
  }, [_vm._v("暂无信息")]) : _vm._e(), _vm._v(" "), (_vm.favoriteList.length) ? _c('table', {
    staticClass: "liststyle",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "3"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.favoriteList), function(row) {
    return _c('tr', {
      key: row.goodsId,
      staticClass: "hovertr"
    }, [_c('td', {
      staticClass: "checkbox"
    }, [_vm._v("  ")]), _vm._v(" "), _c('td', {
      staticClass: "img"
    }, [_c('router-link', {
      staticClass: "img",
      attrs: {
        "to": {
          path: '/goods',
          query: {
            goods_id: row.goodsId
          }
        },
        "title": row.goodsName
      }
    }, [_c('img', {
      attrs: {
        "src": row.thumbnail,
        "height": "55",
        "width": "55"
      }
    })])], 1), _vm._v(" "), _c('td', {
      staticClass: "param"
    }, [_c('dl', [_c('dt', [_c('router-link', {
      attrs: {
        "to": {
          path: '/goods',
          query: {
            goods_id: row.goodsId
          }
        },
        "title": row.goodsName
      }
    }, [_vm._v("\n                      " + _vm._s(row.goodsName) + "\n                    ")])], 1), _vm._v(" "), _c('dd', [_c('span', [_vm._v("商品编号：" + _vm._s(row.goodsSn))])]), _vm._v(" "), _c('dd', [_vm._v("\n                    销售价："), _c('strong', [_vm._v("￥" + _vm._s(row.goodsPrice))])])])]), _vm._v(" "), (row.goodsDisabled == 0 && row.marketEnable == 1) ? _c('td', {
      staticClass: "oper"
    }, [_c('a', {
      staticClass: "del_favorite",
      on: {
        "click": function($event) {
          return _vm.remove(row.goodsId)
        }
      }
    }, [_vm._v("删除")])]) : _vm._e(), _vm._v(" "), (row.goodsDisabled == 1 || row.marketEnable == 0) ? _c('td', {
      staticClass: "oper"
    }, [_c('a', {
      staticClass: "del_favorite",
      on: {
        "click": function($event) {
          return _vm.remove(row.goodsId)
        }
      }
    }, [_vm._v("删除")]), _vm._v(" "), _c('div', {
      staticClass: "product_status"
    }, [_vm._v("失效")])]) : _vm._e()])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.favoriteList.length) ? _c('div', {
    staticClass: "pager_border"
  }, [_c('Page', {
    ref: "pages",
    attrs: {
      "total": _vm.dataTotal,
      "show-total": "",
      "page-size": _vm.pageSize,
      "size": "small",
      "show-elevator": ""
    },
    on: {
      "on-change": _vm.changepage
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.tab == 2) ? _c('div', {
    staticClass: "body"
  }, [(!_vm.collectStoreList.length) ? _c('div', {
    staticClass: "empty"
  }, [_vm._v("暂无信息")]) : _vm._e(), _vm._v(" "), (_vm.collectStoreList.length) ? _c('table', {
    staticClass: "liststyle",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "3"
    }
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.collectStoreList), function(row) {
    return _c('tr', {
      key: row.storeId,
      staticClass: "hovertr"
    }, [_c('td', {
      staticClass: "checkbox"
    }, [_vm._v("  ")]), _vm._v(" "), _c('td', {
      staticClass: "img"
    }, [_c('router-link', {
      staticClass: "img",
      attrs: {
        "to": {
          path: '/shop',
          query: {
            tab: 1,
            store_id: row.storeId
          }
        },
        "title": row.storeName
      }
    }, [_c('img', {
      attrs: {
        "src": row.storeLogo,
        "height": "55",
        "width": "55"
      }
    })])], 1), _vm._v(" "), _c('td', {
      staticClass: "param"
    }, [_c('dl', [_c('dt', [_c('router-link', {
      attrs: {
        "to": {
          path: '/shop',
          query: {
            tab: 1,
            store_id: row.storeId
          }
        },
        "title": row.storeName
      }
    }, [_vm._v("\n                      " + _vm._s(row.storeName) + "\n                    ")])], 1), _vm._v(" "), _c('dd', [_c('span', [_vm._v(_vm._s(row.storeProvince) + " " + _vm._s(row.storeCity) + " " + _vm._s(row.storeRegion))])])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.createTime))]), _vm._v(" "), _c('td', {
      staticClass: "oper"
    }, [_c('a', {
      staticClass: "del_favorite",
      on: {
        "click": function($event) {
          return _vm.remove(row.storeId)
        }
      }
    }, [_vm._v("删除")])])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.collectStoreList.length) ? _c('div', {
    staticClass: "pager_border"
  }, [_c('Page', {
    ref: "pages",
    attrs: {
      "total": _vm.dataTotal,
      "show-total": "",
      "page-size": _vm.pageSize,
      "size": "small",
      "show-elevator": ""
    },
    on: {
      "on-change": _vm.changepage
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "data"
  }, [_c('h2', [_vm._v("我的收藏夹")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip"
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('img', {
    attrs: {
      "src": "//static.kxymall.com/images/gth.jpg"
    }
  }), _vm._v(" "), _c('div', [_c('h2', [_vm._v("温馨提示")]), _vm._v(" "), _c('p', [_vm._v("1、这里将显示您的收藏夹信息。")]), _vm._v(" "), _c('p', [_vm._v("2、您还可以查看您收藏的所有信息、管理您的收藏夹等操作。")])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', [_c('th', [_vm._v("  ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("商品图片")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("商品信息")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("操作")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', [_c('th', [_vm._v("  ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("店铺图片")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("店铺名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("收藏时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("操作")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-234a0905"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/member-center/right/favorite.vue
// module id = 1551
// module chunks = 1